/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { AdminProfilesTable_UserFragmentDoc } from '../../../../../components/organization/AdminProfilesTable/__generated__/useAdminProfilesTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type AdminProfilesIndexPageQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']>;
  pageSize?: Types.InputMaybe<Types.Scalars['Int']>;
  pageNumber?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type AdminProfilesIndexPageQuery = { __typename: 'Query', serviceAdminUsers: { __typename: 'ServiceAdminUsersPayload', totalCount: number, users: Array<{ __typename: 'User', createdAt: any, lastLogin?: any | null, id: string, givenName: string, familyName: string, email: string, roles: Array<Types.Role>, serviceAdminRoles: Array<Types.ServiceAdminRole>, customerIds?: Array<string> | null }> } };


export const AdminProfilesIndexPageDocument = gql`
    query AdminProfilesIndexPage($search: String, $pageSize: Int, $pageNumber: Int) {
  serviceAdminUsers(search: $search, pageSize: $pageSize, pageNumber: $pageNumber) {
    totalCount
    users {
      ...AdminProfilesTable_user
    }
  }
}
    ${AdminProfilesTable_UserFragmentDoc}`;

/**
 * __useAdminProfilesIndexPageQuery__
 *
 * To run a query within a React component, call `useAdminProfilesIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminProfilesIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminProfilesIndexPageQuery({
 *   variables: {
 *      search: // value for 'search'
 *      pageSize: // value for 'pageSize'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useAdminProfilesIndexPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminProfilesIndexPageQuery, AdminProfilesIndexPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminProfilesIndexPageQuery, AdminProfilesIndexPageQueryVariables>(AdminProfilesIndexPageDocument, options);
      }
export function useAdminProfilesIndexPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminProfilesIndexPageQuery, AdminProfilesIndexPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminProfilesIndexPageQuery, AdminProfilesIndexPageQueryVariables>(AdminProfilesIndexPageDocument, options);
        }
export type AdminProfilesIndexPageQueryHookResult = ReturnType<typeof useAdminProfilesIndexPageQuery>;
export type AdminProfilesIndexPageLazyQueryHookResult = ReturnType<typeof useAdminProfilesIndexPageLazyQuery>;
export type AdminProfilesIndexPageQueryResult = ApolloReactCommon.QueryResult<AdminProfilesIndexPageQuery, AdminProfilesIndexPageQueryVariables>;